export const sortedProducts = (campaign, campaignProducts) => {
    if (campaign.catalogType === 6) {
        return [...campaignProducts].sort((a, b) => {
            const aGMV = a.last30DaysGMV || 0;
            const bGMV = b.last30DaysGMV || 0;
            return bGMV - aGMV;
        });
    }
    return campaignProducts;
};
